import { ChangeDetectorRef, Component, HostBinding, OnInit, inject } from '@angular/core';
import {
  AlertModule,
  FooterModule,
  HeaderModule,
  IconModule,
  LinkModule,
  LogoModule,
  MainContentModule,
  NavbarModule,
  SidebarModule,
  ThemingService
} from '@michelin/theme';
import * as moment from 'moment';

import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { ActivatedRoute, Router, RouterLink, RouterOutlet } from '@angular/router';
import { AuthService } from '@michelin/auth';
import { Subscription } from 'rxjs';
import { environment } from '../../environments/environment';
import { AppService } from '../app.service';
import { Applications } from '../interfaces/application';
import { UserData } from '../interfaces/user';
import { AuthenticationWrapperService } from '../services/authentication-wrapper.service';

const darkClassName = 'dark-mode';

@Component({
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  imports: [
    HeaderModule,
    SidebarModule,
    LinkModule,
    RouterLink,
    LogoModule,
    NavbarModule,
    MatButton,
    MatMenuTrigger,
    IconModule,
    MatMenu,
    MatMenuItem,
    MatIconButton,
    MatIcon,
    MainContentModule,
    RouterOutlet,
    FooterModule,
    AlertModule
  ]
})
export class LayoutComponent implements OnInit {
  private readonly themingService = inject(ThemingService);
  private readonly appService = inject(AppService);
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);
  private readonly authWrapperService = inject(AuthenticationWrapperService);
  private readonly cdr = inject(ChangeDetectorRef);

  @HostBinding('class') className = this.themingService.theme.className;

  year = moment.utc().format('YYYY');
  version = environment.version;
  title = 'HBI Application';
  darkMode = this.className === darkClassName;

  applications: Applications[];
  subscription: Subscription;
  subscriptionApp: Subscription;
  selectedApp: string;

  ENVIRONMENT = environment.ENVIRONMENT;
  SHOW_RIBBON = environment.SHOW_RIBBON;

  user: UserData;
  isUserLogin: boolean;
  claims: any;
  /**
   * Toggle theme
   * Light or dark
   */
  setTheme() {
    this.darkMode = !this.darkMode;
    this.className = this.themingService.display(this.darkMode ? darkClassName : '', this.darkMode);
  }

  ngOnInit(): void {
    console.log('the user ', this.user);
    if (this.authService.hasValidIdToken) {
      this.claims = this.authService.getIdentityClaims();

      this.appService.getUsersById(this.claims.uid).subscribe({
        next: (response) => {
          localStorage.setItem('user', JSON.stringify(response));
          this.user = JSON.parse(localStorage.getItem('user'));
          console.log('the user 2', this.user);
          this.applications = this.user.applications;
          if (this.user.role === 'Admin' && this.user.applications.find((c) => c.name === 'HBI') !== undefined) {
            // To navigate beetwen diffrent applications
            this.selectedApp = this.appService.application;
            this.title = this.appService.application + ' Application';
          } else {
            this.selectedApp = this.applications[0].name;
            this.router.navigate([`${this.selectedApp}/csv`], { relativeTo: this.route });
            this.title = this.selectedApp + ' Application';
          }
          this.cdr.detectChanges();
          this.subscriptionApp = this.appService.applicationChanged.subscribe((appName: string) => {
            this.title = appName + ' Application';
            this.selectedApp = appName;
          });
        },
        error: () => {
          this.claims = this.authService.getIdentityClaims();
          const user: UserData = {
            idMichelin: this.claims.subname,
            firstName: this.claims.family_name,
            lastName: this.claims.given_name,
            email: this.claims.email,
            name: this.claims.fullname,
            role: 'simpleUser',
            applications: [],
            status: 'actif'
          };
          localStorage.setItem('user', JSON.stringify(user));
          this.user = JSON.parse(localStorage.getItem('user'));
          this.cdr.detectChanges();
          this.title = this.appService.application + ' Application';
          this.router.navigate([`request`], { relativeTo: this.route });
        }
      });
    }
  }

  onLogout() {
    this.authWrapperService.onLogoutSuccess$.next();
  }

  onChangeApplication(appSelected: Applications) {
    this.appService.onAppChanged(appSelected.name);
  }
}
